import { type JSX } from 'react';
import { Details } from '@gonfalon/ui/details';

import styles from './styles.module.css';

export type CollapsibleInstructionListItemProps = {
  initialOpen: boolean;
  categoryHeader: string;
  categoryInsElems: JSX.Element[];
  hideCategoryHeaders?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export function CollapsibleInstructionListItem({
  categoryHeader,
  initialOpen,
  categoryInsElems,
  hideCategoryHeaders,
  open,
  onOpenChange,
}: CollapsibleInstructionListItemProps) {
  return (
    <li className={styles.collapsibleInstructionListItemCompact}>
      {hideCategoryHeaders ? (
        <ul>{categoryInsElems}</ul>
      ) : (
        <Details
          className={styles.details}
          prependCaret
          initialOpen={initialOpen}
          open={open}
          summary={categoryHeader}
          onOpenChange={onOpenChange}
        >
          <ul>{categoryInsElems}</ul>
        </Details>
      )}
    </li>
  );
}
